import { SVGProps } from "react"

export function ExpandIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 24 24"
      {...props}
    >
      <g>
        <g fill="#000" fillRule="evenodd" clipRule="evenodd">
          <path
            d="M4.5 3.75a.75.75 0 0 0-.75.75v15c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75zm-2.25.75A2.25 2.25 0 0 1 4.5 2.25h15a2.25 2.25 0 0 1 2.25 2.25v15a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25z"
            fill="#000000"
          ></path>
          <path
            d="M16 2.25a.75.75 0 0 1 .75.75v18a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75zM7.47 9.47a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.06-1.06L8.94 12l-1.47-1.47a.75.75 0 0 1 0-1.06z"
            fill="#000000"
          ></path>
          <path
            d="M12.25 3a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75zM12.25 21a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75z"
            fill="#000000"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function MenuItem1Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 506.828 506.828"
      {...props}
    >
      <g>
        <path
          d="M253.414 103.434c48.556 0 87.919 40.52 87.919 90.505s-39.363 90.505-87.919 90.505-87.919-40.521-87.919-90.505 39.363-90.505 87.919-90.505zm0 36.202c-28.324 0-51.717 24.081-51.717 54.303s23.393 54.303 51.717 54.303 51.717-24.081 51.717-54.303-23.393-54.303-51.717-54.303z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="M253.414 0c139.957 0 253.414 113.457 253.414 253.414 0 94.285-51.491 176.544-127.886 220.19-35.728 20.575-77.036 32.582-121.104 33.199l-4.423.025C113.457 506.828 0 393.371 0 253.414S113.457 0 253.414 0zm-23.676 346.505c-46.331 0-87.479 29.378-102.607 73.008l-2.339 7.571c35.919 27.232 80.165 42.893 126.504 43.522l5.709-.009c38.24-.62 74.079-11.122 105.072-29.064l19.977-13.243-2.237-6.866c-14.371-44.046-55.062-74.052-101.239-74.901zm23.676-310.303c-119.963 0-217.212 97.249-217.212 217.212 0 57.493 22.337 109.77 58.807 148.624 21.668-55.072 74.965-91.735 134.73-91.735h46.831c59.905 0 113.311 36.835 134.885 92.121 36.686-38.892 59.172-91.325 59.172-149.01-.001-119.963-97.25-217.212-217.213-217.212z"
          fill="currentColor"
          opacity="1"
        ></path>
      </g>
    </svg>
  )
}

export function MenuItem2Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 100 100"
      {...props}
    >
      <g>
        <path
          d="M83.5 100h-67C7.5 100 0 92.4 0 83.3V46.8c0-4.6 2-9.1 5.5-12.2L39 4.2c6.5-5.6 15.5-5.6 22 0l33.5 30.4c3.5 3 5.5 7.6 5.5 12.2v36.5c-.5 9.6-7.5 16.7-16.5 16.7zM50 10.3c-1.5 0-3 .5-4.5 1.5L12 42.2c-1.5 1-2 3-2 5.1v36.5c0 3.5 3 6.6 6.5 6.6H83c3.5 0 6.5-3 6.5-6.6V47.3c0-2-1-3.5-2-5.1L54 11.8c-1-1-2.5-1.5-4-1.5z"
          fill="currentColor"
          opacity="1"
        ></path>
      </g>
    </svg>
  )
}

export function MenuItem3Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 48 48"
      {...props}
    >
      <g>
        <g fill="#231f20" data-name="11">
          <path
            d="m46.55 28.94-5.64-3.26a15.94 15.94 0 0 0 0-3.36l5.64-3.26a2 2 0 0 0 .73-2.73l-5-8.66a2 2 0 0 0-2.73-.73l-5.64 3.26A16.84 16.84 0 0 0 31 8.52V2a2 2 0 0 0-2-2H19a2 2 0 0 0-2 2v6.52a16.84 16.84 0 0 0-2.91 1.68L8.45 6.94a2 2 0 0 0-2.73.73l-5 8.66a2 2 0 0 0 .73 2.73l5.64 3.26a15.94 15.94 0 0 0 0 3.36l-5.64 3.26a2 2 0 0 0-.73 2.73l5 8.66a2 2 0 0 0 2.73.73l5.65-3.26a16.84 16.84 0 0 0 2.9 1.68V46a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6.52a16.84 16.84 0 0 0 2.91-1.68l5.65 3.26a2 2 0 0 0 2.73-.73l5-8.66a2 2 0 0 0-.73-2.73zm-6.73 7.66-5.08-2.93a2 2 0 0 0-2.3.21 12.93 12.93 0 0 1-4.11 2.37A2 2 0 0 0 27 38.13V44h-6v-5.87a2 2 0 0 0-1.33-1.89 12.93 12.93 0 0 1-4.11-2.37 2 2 0 0 0-2.3-.21L8.18 36.6l-3-5.2 5.08-2.93a2 2 0 0 0 1-2.1 12.49 12.49 0 0 1 0-4.75 2 2 0 0 0-1-2.1L5.18 16.6l3-5.2 5.08 2.93a2 2 0 0 0 2.3-.21 12.93 12.93 0 0 1 4.11-2.37A2 2 0 0 0 21 9.87V4h6v5.87a2 2 0 0 0 1.33 1.89 12.93 12.93 0 0 1 4.11 2.37 2 2 0 0 0 2.3.21l5.08-2.93 3 5.2-5.08 2.93a2 2 0 0 0-1 2.1 12.49 12.49 0 0 1 0 4.75 2 2 0 0 0 1 2.1l5.08 2.93z"
            fill="currentColor"
            opacity="1"
          ></path>
          <path
            d="M24 16a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm0 12a4 4 0 1 1 4-4 4 4 0 0 1-4 4z"
            fill="currentColor"
            opacity="1"
          ></path>
        </g>
      </g>
    </svg>
  )
}
